import { render } from "./TxExport.vue?vue&type=template&id=45bc8ff0"
import script from "./TxExport.vue?vue&type=script&setup=true&lang=js"
export * from "./TxExport.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/TxExport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45bc8ff0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45bc8ff0', __exports__)) {
    api.reload('45bc8ff0', __exports__)
  }
  
  module.hot.accept("./TxExport.vue?vue&type=template&id=45bc8ff0", () => {
    api.rerender('45bc8ff0', render)
  })

}


export default __exports__